import { createContext, useContext } from "react";

import type { PhoneCountry } from "./types";

export interface MruCountryValue {
  country: PhoneCountry | undefined;
  setCountry: (country: PhoneCountry) => void;
}

const noop = () => {};

const defaultValue: MruCountryValue = {
  country: undefined,
  setCountry: noop,
};

export const MruCountryContext = createContext<MruCountryValue>(defaultValue);

export function useMruCountry(): MruCountryValue {
  const context = useContext(MruCountryContext);
  return context ?? defaultValue;
}
